import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "14",
      cy: "14",
      r: "14",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#3D2669",
      "fill-rule": "evenodd",
      d: "M21.315 10.664c-1.62 1.833-3.238 3.606-4.857 5.439s-3.658 5.927-5.517 2.689l-4.497-7.7c-1.259-2.139.42-3.3 1.799-1.161l4.497 7.516c2.398-2.933 4.797-5.866 7.196-8.739 1.559-1.772 2.938.123 1.379 1.956",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }